module.exports = __webpack_public_path__ + "img/topic-trends.2d6da22f.png";